define('native/viewmodels/Login',[],function () {

    return function NativeLoginViewModel (
        loginViewModel,
        touchIdModel,
        touchIdContent,
        nativeMessagenger,
        messageChannels
    ) {

        var self = loginViewModel;

        self.touchIdImage = touchIdContent.findFieldByName('touch_id_setup_image');

        self.loginWithTouchId = function () {
            nativeMessagenger.sendMessage(messageChannels.LOGIN_WITH_TOUCH_ID);
        };

        self.shouldShowTouchId = touchIdModel.shouldShowTouchIdForLogin;

        self.getView = function () {
            return 'native/views/Login.html';
        };

        return self;
    };
});


